import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { EnvironmentService } from '../../services/img-source.service';
import { ASSETS_PATH_CONST } from '../../../modern-multi-trip-view/constants/image-assets.constants';

@Component({
  selector: 'app-side-bar-tr',
  templateUrl: './side-bar-tr.component.html',
  styleUrls: ['./side-bar-tr.component.scss'],
})
export class SideBarTripReplayComponent implements OnInit {
  @Input() isCabView: boolean = false;
  @Input() adhoc_text;
  imgSrc: string;
  replayImgSrc: string;
  activeTab: String = 'events';
  tripDetails: any;
  INFO_ICON;
  adhocTooltipVisible: boolean = false;
  ASSETS_PATH_CONST = ASSETS_PATH_CONST;
  constructor(private commonService: CommonService, private envService: EnvironmentService) { }

  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
    this.replayImgSrc = this.envService.getReplayImgSrc();
    this.tripDetails = this.commonService.response['tripDetails'];
    this.INFO_ICON = `${this.imgSrc}assets/icons/info_icon.svg`;
    console.log('tripDetals in side', this.tripDetails);
  }

  toolTipClose(){
    this.adhocTooltipVisible = false;
  }

  goToTripView() {
    this.commonService.goToTripView();
  }

  setActiveTab(tabname: String): void {
    this.activeTab = tabname;
  }
}
